// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C33x3TbcJ15RLRkWyDFl {
  background-color: var(--home-page-top-background-v2);
}

.UxYA4CW2gG563hkza6PB {
  height: 2.75rem;
}

.Owfw11zmEV78KWfo4sJd {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-gap: 2rem;
  gap: 2rem;
}

.ADEORH0Z2j1o0uKSVWW_ {
  background-color: transparent;
  height: auto
}

.ADEORH0Z2j1o0uKSVWW_ .Owfw11zmEV78KWfo4sJd {
    padding: 0;
    height: auto;
  }

.ADEORH0Z2j1o0uKSVWW_ .UxYA4CW2gG563hkza6PB {
    height: auto;
  }

.nLXCoKhbJLXlNPPrObjT {
  height: 3.5rem;
  background-color: var(--home-page-top-background-v2);
}

.xgvIJmK7MaBZRqeFZoAl {
  display: none;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
      .ADEORH0Z2j1o0uKSVWW_ .UxYA4CW2gG563hkza6PB img {
        max-width: 7.5rem;
      }
}

@media only screen and
  (max-width: 639px) {
  .ADEORH0Z2j1o0uKSVWW_ {
    position: absolute;
    right: var(--horizontal-padding);
    padding-top: 0.375rem;
    z-index: 1
  }
      .ADEORH0Z2j1o0uKSVWW_ .UxYA4CW2gG563hkza6PB img {
        max-width: 6.25rem;
      }
}
`, "",{"version":3,"sources":["webpack://./src/components/Trustmarks/Trustmarks.module.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;AACtD;;AAEA;EACE,eAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B;AAUF;;AARE;IACE,UAAU;IACV,YAAY;EACd;;AAEA;IACE,YAAY;EACd;;AAGF;EACE,cAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;;;MAGM;QACE,iBAAgB;MAClB;AAGN;;AAEA;;EACE;IACE,kBAAkB;IAClB,gCAAgC;IAChC,qBAAgB;IAChB;EAOF;MAJI;QACE,kBAAgB;MAClB;AAGN","sourcesContent":[".trustmarksWrapper {\n  background-color: var(--home-page-top-background-v2);\n}\n\n.trustmark {\n  height: 44px;\n}\n\n.trustmarksInnerWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 32px;\n}\n\n.trustmarksWrapperTopbar {\n  background-color: transparent;\n  height: auto;\n\n  & .trustmarksInnerWrapper {\n    padding: 0;\n    height: auto;\n  }\n\n  & .trustmark {\n    height: auto;\n  }\n}\n\n.empty {\n  height: 56px;\n  background-color: var(--home-page-top-background-v2);\n}\n\n.emptyTopbar {\n  display: none;\n}\n\n@media (--tablet) {\n  .trustmarksWrapperTopbar {\n    & .trustmark {\n      & img {\n        max-width: 120px;\n      }\n    }\n  }\n}\n\n@media (--mobile) {\n  .trustmarksWrapperTopbar {\n    position: absolute;\n    right: var(--horizontal-padding);\n    padding-top: 6px;\n    z-index: 1;\n\n    & .trustmark {\n      & img {\n        max-width: 100px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trustmarksWrapper": `C33x3TbcJ15RLRkWyDFl`,
	"trustmark": `UxYA4CW2gG563hkza6PB`,
	"trustmarksInnerWrapper": `Owfw11zmEV78KWfo4sJd`,
	"trustmarksWrapperTopbar": `ADEORH0Z2j1o0uKSVWW_`,
	"empty": `nLXCoKhbJLXlNPPrObjT`,
	"emptyTopbar": `xgvIJmK7MaBZRqeFZoAl`
};
export default ___CSS_LOADER_EXPORT___;
